import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EParamChannelTypeGlobal,
  EReportColumnHeader,
  EReportingTimeWindow,
  IReportingAdvertisersTableResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import { TAdvertisersReportTableFilters, TPPRetailerId } from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetRetailerReportingAdvertisersTableV3({
  retailerId,
  advertiserId,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  channelType,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & TAdvertisersReportTableFilters &
  TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingAdvertisersTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingAdvertisersTable_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate }],
    () => {
      return coreAPIV3.retailerReporting().getRetailerAdvertisersReportTable(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        sortBy as EReportColumnHeader,
        sortOrder,
        timeWindow as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        pageLimit,
        pageOffset,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status,
        channelType as EParamChannelTypeGlobal | undefined
      )
    },
    { suspense, enabled }
  )
}
